import { Button, Card, Col, Modal, Popconfirm, Row } from "antd";
import React, { useState, useEffect } from "react";
import { H6 } from "../../../../AbstractElements";
import { CheckCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import {
  ConfigApprovalFlowApi,
  OrganisationUsers,
  ProjectFlowMembersApi,
} from "../../../../api";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { recreateApprovalFlowForProject } from "../../../../api/project.api";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const ApprovalFlow = (props) => {
  const [modal1Visible, setModal1Visible] = useState(false);
  const [flowDetails, setFlowDetails] = useState([]);
  const [flowMemberDetails, setFlowMemberDetails] = useState([]);
  const [userOrganisation, setUserOrganisation] = useState([]);
  useEffect(() => {
    fetchFlowDetails({
      organisation: props.settings?.user?.organisation?.organisation_id,
      project: props.settings?.project?.id,
      branch: props.settings?.branch?.id,
    });
    fetchFlowMembers({ project_member__project: props.settings?.project?.id });
    fetchUserOrganisation({ branch: props?.settings?.branch?.id });
  }, []);
  const fetchFlowDetails = (params = {}) => {
    axios
      .get(`${ConfigApprovalFlowApi}`, { params: { ...params } })
      .then((res) => {
        setFlowDetails(res.data);
      });
  };
  const fetchFlowMembers = (params = {}) => {
    axios
      .get(`${ProjectFlowMembersApi}`, { params: { ...params } })
      .then((res) => {
        var data = res.data;
        console.log(data);
        setFlowMemberDetails(data);
      });
  };
  const fetchUserOrganisation = (params = {}) => {
    axios
      .get(`${OrganisationUsers}`, {
        params: { ...params, user__is_active: true },
      })
      .then((res) => {
        setUserOrganisation(res.data);
      });
  };
  const handleMember = (data, item) => {
    console.log(data, item, "sss");
    var flow = data?.id;
    var member = item?.project_member_id;
    var obj = flowDetails;
    for (var i = 0; i < obj?.length; i++) {
      if (obj[i].id === flow) {
        var newObj = obj[i]?.proj_approval_flow_member;
        for (var j = 0; j < newObj?.length; j++) {
          if (newObj[j]?.project_member_id === member) {
            if (newObj[j].is_selected == "true") {
              newObj[j].is_selected = "false";
            } else {
              newObj[j].is_selected = "true";
            }
          } else {
            newObj[j].is_selected = "false";
          }
        }
      }
    }
    console.log(obj);
    setFlowDetails([...obj]);
  };
  const changeFlow = () => {
    var obj = flowDetails;
    console.log(obj, "obj");
    var num = 0;
    var i = 0;
    var payloadArr = [];
    for (var i = 0; i < obj?.length; i++) {
      const formData = {
        organisation_approval_flow: obj[i]?.id,
      };
      var newObj = obj[i]?.proj_approval_flow_member;
      for (var j = 0; j < newObj?.length; j++) {
        if (newObj[j]?.is_selected === "true") {
          formData.project_member = newObj[j].project_member_id;
          payloadArr.push(formData);
        }
      }
    }
    axios
      .post(`${ProjectFlowMembersApi}`, payloadArr)
      .then(() => {
        toast.success("Flow Updated Successfully!");
        setModal1Visible(false);
        fetchFlowDetails({
          organisation: props.settings?.user?.organisation?.organisation_id,
          project: props.settings?.project?.id,
          branch: props.settings?.branch?.id,
        });
        fetchFlowMembers({
          project_member__project: props.settings?.project?.id,
        });
        fetchUserOrganisation();
      })
      .catch(() => {
        toast.error("Something went wrong!");
      });
  };
  return (
    <React.Fragment>
      <div className="my-2">
        <Button
          className="btn btn-primary text-white"
          onClick={() => setModal1Visible(true)}
        >
          Configure Approval Flow
        </Button>
        <Button
          className="btn btn-primary text-white mx-2"
          onClick={() => {
            recreateApprovalFlowForProject({
              project_id: props.settings?.project?.id,
            });
          }}
        >
          ReConfigure Approval Flow
        </Button>
        <div className="my-3 row px-3">
          {flowMemberDetails?.map((each, index) => (
            <div
              className="col-md-4 shadow-sm p-3 rounded m-2"
              key={index}
              style={{ boxShadow: "#67978E 0px 1px 3px, #67978E 0px 1px 2px" }}
            >
              <div className="px-2 d-flex justify-content-between">
                <div className="">
                  {each?.organisation_approval_flow?.approval_flow_name}
                </div>
              </div>
              <div className="my-1">
                <hr />
              </div>
              <Row className="my-2">
                <Col sm={12} className="">
                  Approver
                </Col>
                <Col sm={12} className="">
                  :{" "}
                  {
                    userOrganisation?.filter(
                      (i) => i.id === each?.project_member?.user_organisation
                    )[0]?.user?.name
                  }
                </Col>
              </Row>
              <Row className="">
                <Col sm={12} className="">
                  Threshold
                </Col>
                <Col sm={12} className="">
                  :{each?.organisation_approval_flow?.approval_limit}
                </Col>
              </Row>
            </div>
          ))}
        </div>
      </div>
      <Modal
        title="Add Step"
        centered
        visible={modal1Visible}
        width="1000px"
        onCancel={() => {
          //   formRef.current.resetFields();
          setModal1Visible(false);
        }}
        footer={[
          <Button
            key="submit"
            className="btn btn-primary text-white"
            htmlType="submit"
            onClick={() => {
              changeFlow();
            }}
          >
            Submit
          </Button>,
          <Button
            key="back"
            onClick={() => {
              //   formRef.current.resetFields();
              setModal1Visible(false);
            }}
          >
            Cancel
          </Button>,
        ]}
      >
        <div style={{ display: "flex", overflowX: "scroll" }}>
          {flowDetails?.map((each, index) => (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "20px",
              }}
              key={index}
            >
              <div
                className="rounded"
                style={{
                  padding: 12,
                  minWidth: "300px",
                  minHeight: "200px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                }}
              >
                <div className="my-2 text-center">
                  <div className="">
                    <H6>{each?.approval_flow_name}</H6>
                  </div>
                  <div className="mt-2">
                    <H6>
                      Threshold Limit {">"}{" "}
                      {props.settings?.project?.currency?.symbol ?? "₹"}
                      {each?.approval_limit}
                    </H6>
                  </div>
                </div>
                {each?.proj_approval_flow_member?.map((item) => (
                  <div
                    className="shadow-sm rounded d-flex"
                    style={{
                      padding: 16,
                      margin: "0 0 8px 0",
                      minHeight: "50px",
                      backgroundColor: "#ADC7FC",
                      color: "white",
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleMember(each, item);
                    }}
                  >
                    {item?.is_selected == "true" && (
                      <div style={{ position: "absolute", right: 10 }}>
                        <CheckCircleOutlined style={{ fontSize: "20px" }} />
                      </div>
                    )}
                    <div className="">
                      {item?.organisation_member__user__name}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default connect(mapStateToProps)(ApprovalFlow);
